import React, { useEffect, useMemo, useState } from "react";
import AdminUserService from "../../../services/adminUserServices";
import { Column, useSortBy, useTable } from "react-table";
import ReactModal from "react-modal";
import { Button, Label, PageLink } from "../../../components/StyledComp/StyledComp";
import { useForm } from "react-hook-form";
import ButtonWithIcon from "../../../components/StyledComp/ButtonWithIcon";
import "../../../Styles/CommonStyles.scss";
import EditIcon from '@mui/icons-material/Edit';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { useAppSelector } from "../../../store/hooks";

// Set the app element for accessibility
ReactModal.setAppElement('#root'); // or the id of your root element if it's different



interface AddFormValue {
  MemberCode: string | null;
  Description: string | null;
  FromYear: number | null;
  ToYear: number | null;
  AdvanceMemberCode: string | null;
  Fee: number | null;
  Status: string | null;
  SectionStatus: string | null;
}

interface Istate {
  data: {
    MemberCode: string;
    Description: string;
    FromYear: number;
    ToYear: number;
    AdvanceMemberCode: string;
    Fee: number;
    Status: string;
    SectionStatus: string;
  }
}

const MemberCode: React.FC = () => {


  const [memberCode, setMemberCode] = useState<any[] | undefined>([]);
  const [dialogTitle, setdialogTitle] = useState<string>('Add Member Code');

  // const [MemberCodeInput, setMemberCodeInput] = useState<string | undefined>();
  // const [Description, setDescription] = useState<string | undefined>();
  // const [FromYear, setFromYear] = useState<number | undefined>();
  // const [ToYear, setToYear] = useState<number | undefined>();
  // const [AdvanceMemberCode, setAdvanceMemberCode] = useState<string | undefined>();
  // const [Fee, setFee] = useState<number | undefined>();
  // const [Status, setStatus] = useState<number>(1);
  const [Id, setId] = useState<number>(1);
  const [selectedRow, setSelectedRow] = useState<any | undefined>();
  const [addCodeOpen, setaddCodeOpen] = useState<boolean>(false);
  const [isEdit, setisEdit] = useState<boolean>(false);
  const form = useForm<AddFormValue>();
  const { register, control, handleSubmit, formState, setValue, reset } = form;
  const { errors, touchedFields, dirtyFields } = formState;
  const roleCapabilites = useAppSelector((state) => state.user.roleCapabilities);


  const getMemberCode = async () => {
    const response = await AdminUserService.getMemberCode();
    console.log(response);
    if (response.data.data != null) {
      setMemberCode(response.data.data);
    } else {
      alert(response.data.errors[0]);
    }
  };
  useEffect(() => {
    getMemberCode();
  }, []);

  const addMemberCode = async (data: any) => {
    const response = await AdminUserService.addMemberCode(data);
    console.log(response);
    if (response.data.data != null) {
      // setMemberCode(response.data.data);
      getMemberCode()
      setaddCodeOpen(false)
      alert('Member Code Added Successfully');

    } else {
      alert(response.data.errors[0]);
    }
  };

  const updateMemberCode = async (data: any) => {
    const response = await AdminUserService.updateMemberCode(data);
    console.log(response);
    if (response.data.data != null) {
      // setMemberCode(response.data.data);
      getMemberCode()
      setaddCodeOpen(false)
      alert('Member Code updated Successfully');

    } else {
      alert(response.data.errors[0]);
    }
  };
  const columns = React.useMemo<Column<any>[]>(
    () => [
      { id: "Id", Header: "ID", accessor: "Id" },
      { id: "MemberCode", Header: "MemberCode", accessor: "MemberCode" },
      { id: "Description", Header: "Description", accessor: "Description" },
      { id: "FromYear", Header: "FromYear", accessor: "FromYear" },
      { id: "ToYear", Header: "ToYear", accessor: "ToYear" },
      { id: "AdvanceMemberCode", Header: "AdvanceMemberCode", accessor: "AdvanceMemberCode" },
      { id: "Fee", Header: "Fee", accessor: "Fee" },
      {
        id: "Status", Header: "Status", accessor: "Status",
        Cell: ({ value }: { value: number }) => (
          <span>{value === 1 ? 'Active' : 'Inactive'}</span>
        )
      },
      {
        id: "SectionStatus", Header: "Section Status", accessor: "SectionStatus",
        Cell: ({ value }: { value: number }) => (
          <span>{value === 1 ? 'Active' : 'Inactive'}</span>
        )
      },
      {
        id: "edit",
        Header: "Action",
        accessor: (row: any) => (
          <a className="d-flex editRow justify-content-center" onClick={() => handleEdit(row)}><EditIcon></EditIcon></a>
        ),
      }
    ],
    []
  );

  const handleEdit = (rowData: any) => {
    if (! roleCapabilites.some((obj: any) => Object.values(obj).includes('settings.edit'))) {
      alert("No Access");
      return;
    }
    console.log("Edit clicked for row:", rowData);
    setId(rowData.Id)
    setisEdit(true)
    setSelectedRow(rowData);
    reset()
    setValue('MemberCode', rowData.MemberCode)
    setValue('Description', rowData.Description)
    setValue('FromYear', rowData.FromYear)
    setValue('ToYear', rowData.ToYear)
    setValue('AdvanceMemberCode', rowData.AdvanceMemberCode)
    setValue('Fee', rowData.Fee)
    setValue('Status', rowData.Status)
    setValue('SectionStatus', rowData.SectionStatus || '1')


    setdialogTitle('Update Member Code')
    setaddCodeOpen(true);
  };

  const data = useMemo(() => memberCode, [memberCode])!;

  const TableInstance = useTable({
    columns,
    data,
  }, useSortBy);

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    TableInstance;
  let index = 0;

  const onSubmit = (data: AddFormValue) => {
    const MemberCode = data.MemberCode || '';
    const FromYear = data.FromYear || '';
    const ToYear = data.ToYear || '';
    const AdvanceMemberCode = data.AdvanceMemberCode || '';
    const description = data.Description || '';
    const status = data.Status !== undefined ? data.Status : '';
    const sectionStatus = data.SectionStatus !== undefined ? data.SectionStatus : '1';
    const Fee = data.Fee !== undefined ? data.Fee : '';

    // let data = {
    //     'SectionName': MemberSectionInput,
    //     'SectionDescription': Description,
    //     'Fee': Fee,
    //     'Status': Status
    // }
    const formData = {
      MemberCode: MemberCode,
      Description: description,
      Status: Number(data.Status || 1),
  SectionStatus: Number(data.SectionStatus || 1),
      Fee: Fee,
      FromYear: FromYear,
      ToYear: ToYear,
      AdvanceMemberCode: AdvanceMemberCode
    };
    let id = {
      'Id': Id
    }
    console.log("SUBMIT");
    // console.log(e)
    console.log(data)
    console.log(formData)
    isEdit ? updateMemberCode({ ...formData, ...id }) : addMemberCode(formData)
  };



  // const updateStatus = (event: React.ChangeEvent<HTMLSelectElement>): void => {
  //   console.log(event.target.name, event.target.value)
  //   setStatus(parseInt(event.target.value))

  // };

  const openDialog = () => {
    if (! roleCapabilites.some((obj: any) => Object.values(obj).includes('settings.create'))) {
      alert("No Access");
      return;
    }
    setisEdit(false)
    setValue('MemberCode', '')
    setValue('Description', '')
    setValue('FromYear', 0)
    setValue('ToYear', 0)
    setValue('AdvanceMemberCode', '')
    setValue('Fee', 0)
    setValue('Status', '1')
    setValue('SectionStatus', '1')
    setaddCodeOpen(true)
    setdialogTitle('Add Member Code')
  }

  const handleClose = () => {
    reset()
    setaddCodeOpen(false)
  }
  return (
    <div className="container-fluid">
      <div className="dashboard-content-wrapper">
        <div className="d-flex justify-content-between" style={{ width: "90%" }}>
          <h1 className="page-heading">Member Code</h1>
          <div className="settings-add-button ms-4">
            <div className="secondary-button" onClick={() => openDialog()}>
              <AddCircleOutlineIcon></AddCircleOutlineIcon>
              <span className="ps-1">Add Member Code</span>
            </div>
            {/* <ButtonWithIcon
              icon={<></>}
              buttontext="Add Member Code"
              onClick={() => openDialog()}
            /> */}
          </div>

        </div>

        <div className="memberCode-table">
          <table {...getTableProps}>
            <thead>
              {headerGroups.map((headerGroup) => (
                <tr {...headerGroup.getHeaderGroupProps} key={index++}>
                  {headerGroup.headers.map((column) => (
                    <th {...column.getHeaderProps()} key={column.id}>
                      {column.render("Header")}
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody {...getTableBodyProps}>
              {rows.map((row) => {
                prepareRow(row);
                return (
                  <tr {...row.getRowProps()} key={row.index}>
                    {row.cells.map((cell) => {
                      return (
                        <td {...cell.getCellProps()}> {cell.render("Cell")}</td>
                      );
                    })}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
      <ReactModal isOpen={addCodeOpen} className="addtype-modal" overlayClassName="overlay">
        <div
          className="horizontal-wrapper-spacebetween"
          style={{ marginBottom: "1rem", zIndex: "20", height: "5%" }}
        >
          <h1
            className="page-heading"
          // style={{ marginBottom: "2rem", }}
          >
            {dialogTitle}
          </h1>
          <PageLink
            onClick={() => handleClose()}
            style={{ marginBottom: "1rem" }}
          >
            Cancel
          </PageLink>
        </div>
        <form

          onSubmit={handleSubmit(onSubmit)}
        >
          <div className="d-flex">
            <div className="input-field-div-wrapper w-100">
              <Label>Member Code</Label>
              <input
                className="input-field-div"
                placeholder="Member Code"
                {...register("MemberCode", { required: "Member Code is required" })}
                name="MemberCode" id="MemberCode"

              />
              <p className="form-error form-error-position">
                {errors.MemberCode?.message}
              </p>
            </div>
            <div className="input-field-div-wrapper w-100 mx-3">
              <Label>Description</Label>
              <input
                className="input-field-div"
                placeholder="Description"
                {...register("Description", { required: false })}

                name="Description" id="Description"
                autoComplete="off"

              />
            </div>
            <div className="input-field-div-wrapper w-100">
              <Label>From Year</Label>
              <input
                className="input-field-div"
                placeholder="From Year"
                {...register("FromYear", { required: false })}

                name="FromYear" id="FromYear"
                autoComplete="off"

              />
            </div>
          </div>
          <div className="d-flex">
            <div className="input-field-div-wrapper w-100">
              <Label>To Year</Label>
              <input
                className="input-field-div"
                placeholder="To Year"
                {...register("ToYear", { required: false })}

                name="ToYear" id="ToYear"

                autoComplete="off"
              />
            </div>
            <div className="input-field-div-wrapper w-100 mx-3">
              <Label>Advance Member Code</Label>
              <input
                className="input-field-div"
                placeholder="Advance Member Code"
                {...register("AdvanceMemberCode", { required: false })}

                name="AdvanceMemberCode" id="AdvanceMemberCode"
                autoComplete="off"
              />
              <p className="form-error form-error-position">
                {errors.AdvanceMemberCode?.message}
              </p>
            </div>
            <div className="input-field-div-wrapper w-100">
              <Label>Fee</Label>
              <input
                className="input-field-div"
                placeholder="Fee"
                {...register("Fee", { required: 'Fee is required' })}

                name="Fee" id="Fee"
                autoComplete="off"
              />
              <p className="form-error form-error-position">
                {errors.Fee?.message}
              </p>
            </div>
          </div>
          <div className="d-flex">
            <select style={{ marginTop: "6px" }}
              className="dropdown-control-large"
              {...register("Status", { required: false })}

              name="Status"

              id='Status'
            >
              <option value="1">Active</option>
              <option value="0">Inactive</option>
            </select>
            <select style={{ marginTop: "6px" }}
              className="dropdown-control-large"
              {...register("SectionStatus", { required: false })}
              name="SectionStatus"
              id='SectionStatus'
            >
              <option value="1">Active</option>
              <option value="0">Inactive</option>
            </select>
          </div>
          <div className="w-100 d-flex justify-content-center">
            <div className="submit-button-div">
              <Button type="submit">{isEdit ? 'Update' : 'Add'}</Button>
            </div>
          </div>
        </form>
      </ReactModal>
    </div>

  );
};

export default MemberCode;
